module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "c-header"
  }, [_vm._m(0), _vm._v(" "), _c('nav', {
    staticClass: "c-nav"
  }, _vm._l((_vm.navItems), function(navItem) {
    return _c('a', {
      key: navItem.text,
      class: _vm.getClasses(navItem.active),
      attrs: {
        "href": navItem.url
      }
    }, [_vm._v(_vm._s(navItem.text))])
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-logo",
    attrs: {
      "href": "http://www.spinneybeck.com"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Spinneybeck",
      "src": require("../../assets/spin-logo.png"),
      "width": "285",
      "height": "50"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b0137c32"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/pages/wrappers/HeaderSpinneybeck.vue
// module id = 573
// module chunks = 1